// JSON File Updater Actions
const JFU_RESET_FILE_UPDATE = 'JFU_RESET_FILE_UPDATE';
const JFU_UPDATE_JSON_VALUE = 'JFU_UPDATE_JSON_VALUE';
const JFU_ON_UPDATE_JSON_FILE = 'JFU_ON_UPDATE_JSON_FILE';

export const actionTypes = {
  JFU_RESET_FILE_UPDATE,
  JFU_UPDATE_JSON_VALUE,
  JFU_ON_UPDATE_JSON_FILE,
};